import axios from 'axios'
import { MessageBox, Message, Loading } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import config from '@/config/index'
import { saveAs } from 'file-saver'
import { tansParams, blobValidate } from "@/utils/ruoyi";
let downloadLoadingInstance;
const service = axios.create({
  baseURL: config.apiRequestUrl,
  timeout: 600000,
})
service.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      if (config.method == 'get') {
        if (!config.params) {
          config.params = {}
        }
        config.params.accToken = getToken()
      }
      if (config.method == 'post') {
        if (!config.data) {
          config.data = {}
        }
        config.data.accToken = getToken()
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.code !== 200) {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000,
      })
      if (res.code == 99) {
        return res
      }
      if (res.code === 1 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm('您登录的网站已离线，您是否重新登录？', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      // 取消跳入reject
      // return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  (error) => {
    Message({
      message: '网络异常，请您检查是否可以上网？',
      type: 'error',
      duration: 5 * 1000,
    })
    return Promise.reject(error)
  }
)

// 通用下载方法
// export function download (url, params, filename, config) {
//   downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
//   return service.post(url, params, {
//     transformRequest: [(params) => { return tansParams(params) }],
//     headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//     responseType: 'blob',
//     ...config
//   }).then(async (data) => {
//     const isBlob = blobValidate(data);
//     if (isBlob) {
//       const blob = new Blob([data])
//       saveAs(blob, filename)
//     } else {
//       const resText = await data.text();
//       const rspObj = JSON.parse(resText);
//       const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
//       Message.error(errMsg);
//     }
//     downloadLoadingInstance.close();
//   }).catch((r) => {
//     console.error(r)
//     Message.error('下载文件出现错误，请联系管理员！')
//     downloadLoadingInstance.close();
//   })
// }
export function download (url, params, filename) {
  console.log(params);
  downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
  axios({
    method: "post",
    url: config.apiRequestUrl + url,
    timeout: 60000,
    responseType: 'blob',
    params: params,
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded",
    //   "Authorization": "Bearer " + getToken(),
    // },
  })
    .then(async (data) => {
      console.log(data);
      if (data.status == 200) {
        const isLogin = await blobValidate(data.data);
        if (isLogin) {
          const blob = new Blob([data.data])
          saveAs(blob, filename)
        } else {
          const resText = await data.data.text();
          const rspObj = JSON.parse(resText);
          const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
          Message.error(errMsg);
        }
        console.log(111);
        downloadLoadingInstance.close();
      } else {
        console.log(123123);
        Message.error('下载文件出现错误，请联系管理员！')
      }

    }).catch((r) => {
      console.log(321321);
      Message.error('下载文件出现错误，请联系管理员！')
      downloadLoadingInstance.close();
    })
}

export function downloadData (url, params, filename) {
  console.log(params);
  downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
  axios({
    method: "post",
    url: config.apiRequestUrl + url,
    timeout: 60000,
    responseType: 'blob',
    data: params,
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded",
    //   "Authorization": "Bearer " + getToken(),
    // },
  })
    .then(async (data) => {
      console.log(data);
      if (data.status == 200) {
        const isLogin = await blobValidate(data.data);
        if (isLogin) {
          const blob = new Blob([data.data])
          saveAs(blob, filename)
        } else {
          const resText = await data.data.text();
          const rspObj = JSON.parse(resText);
          const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
          Message.error(errMsg);
        }
        console.log(111);
        downloadLoadingInstance.close();
      } else {
        console.log(123123);
        Message.error('下载文件出现错误，请联系管理员！')
      }

    }).catch((r) => {
      console.log(321321);
      Message.error('下载文件出现错误，请联系管理员！')
      downloadLoadingInstance.close();
    })
}
export default service
